
import { Vue, Component, Prop } from "vue-property-decorator";
import {
  Contractor_Staff_Note,
  Project,
  Project_Activity,
  Query_RootContractor_Staff_NoteArgs,
  User,
} from "@/generated/graphql";
import GET_CONTRACTORS_STAFF_NOTES from "@/apollo/contractors/GetContractorStaffNotes.gql";
import CREATE_CONTRACTORS_STAFF_NOTES from "@/apollo/contractors/InsertContractorStaffNotes.gql";
import CloseOutlinedGray from "@/components/icons/CloseOutlinedGray.vue";
import TabNotificationBubble from "@/components/common/TabNotificationBubbleNew.vue";
import ModalFullScreen from "@/components/modal/ModalFullScreenNew.vue";
import ModalContent from "@/components/modal/ModalContent.vue";
import UiButton from "@/components/button/ui-button.vue";
import FormTextarea from "@/components/form/FormTextarea.vue";
import FormGroup from "@/components/form/FormGroup.vue";
import moment from "moment";
import ContractorStaffNotesCard from "./ContractorStaffNotesCard.vue";
import { NOTIFICATION } from "@/entities/Events";
import Message from "@/data/notificationsMessages";
import InfoCircleFilled from "@/components/icons/InfoCircleFilled.vue";
import Roles from "@/entities/Roles";

@Component({
  components: {
    ModalFullScreen,
    FormTextarea,
    FormGroup,
    ModalContent,
    UiButton,
    CloseOutlinedGray,
    InfoCircleFilled,
    TabNotificationBubble,
    ContractorStaffNotesCard,
  },
  apollo: {
    notes: {
      query: GET_CONTRACTORS_STAFF_NOTES,
      variables() {
        return this.staffNotesFilter;
      },
      update(data) {
        this.totalStaffNotes = data.total.aggregate.count;
        return data.notes;
      },
    },
  },
})
export default class ActivityNotesModal extends Vue {
  @Prop({ type: Object, required: true }) readonly project!: Project;
  @Prop({ type: Object, required: true }) readonly activity!: Project_Activity;
  @Prop({ type: Object, required: true }) readonly currentUser!: User;
  @Prop({ type: Boolean, required: false }) readonly isCalendarNotes: Boolean;

  totalStaffNotes: number = 0;
  currentTab: string = "manager"; // Tracks the active tab
  editedDate: string = "Dec 17, 2024";
  notes: Contractor_Staff_Note[] = [];
  noBtnText: string = "Close";
  staffNote: string = "";

  get managerNote(): string {
    if (this.activity.extra_notes) {
      return this.activity.extra_notes;
    } else {
      return "There are currently no notes from your Manager";
    }
  }
  get isResources(){
    return this.currentUser.role === Roles.CONTRACTOR;
  }

  get managerDate(): string {
    if (
      this.activity.extra_notes_updated_at &&
      this.activity.extra_notes_updated_at !=
        this.activity.extra_notes_created_at
    ) {
      return `Edited on ${this.formattedDate(
        this.activity.extra_notes_updated_at
      )} at ${this.formattedTime(this.activity.extra_notes_updated_at)}`;
    } else if (this.activity.extra_notes_created_at) {
      return `${this.formattedDate(
        this.activity.extra_notes_created_at
      )} at ${this.formattedTime(this.activity.extra_notes_created_at)}`;
    } else {
      // if (this.activity.extra_notes) {
      //   return "n/a";
      // } else {
        return "";
    }
  }

    get isAdmin(): boolean {
      return this.currentUser.role === Roles.ADMIN;
    }

    get isManager(): boolean {
      return this.currentUser.role === Roles.MANAGER;
    }

  get staffNotesFilter(): Query_RootContractor_Staff_NoteArgs {
    if (this.isCalendarNotes) {
      return {
        where: {
          _and:  [
            {
               project_activity_id: {
              _eq: this.activity.id,
            },
            },
            {
              project: {
                id:{
                _eq: this.project.id,
              },
            },
            }
          ],
        },
      };
    } else {
      // const currentContractorActivity = this.project.project_activities.find(
      //   (each) => each.contractor.user.id === this.currentUser.id
      // );

      return {
        where: {
          _and: [
            {
              project_activity_id: {
                _eq: this.activity.id,
            },
              project: {
                id:{
                _eq: this.project.id,
              },
            },
            }
            // {
            //   contractor_id: {
            //     _eq: currentContractorActivity.contractor.id,
            //   },
            // },
          ],
        },
      };
    }
  }

  async saveNote() {
    if (!this?.staffNote?.trim()) {
      this.$eventBus.emit(NOTIFICATION, Message.errorMessage("Note cannot be empty"));
      return;
    }
    const currentContractorActivity = this?.project.project_activities?.find(
      (each) => each.contractor.user.id === this.currentUser.id
    ) ;
    const variables = {
      object: {
        contractor_id: currentContractorActivity?.contractor?.id  || this.activity?.contractor_id,
        note: this?.staffNote,
        project_activity_id: this?.activity?.id,
        project_id: this.activity?.project?.id,
      },
    };
    try {
      const resp = await this.$apollo.mutate({
        mutation: CREATE_CONTRACTORS_STAFF_NOTES,
        variables,
      });
      this.$apollo.queries.notes.refetch();
      this.staffNote = "";
    } catch (error) {
      this.$eventBus.emit(NOTIFICATION, Message.errorMessage(error instanceof Error ? error.message : "An error occurred"));
    }
  }

  formattedDate(date: string): string {
    if (date) {
      return moment(date).format("ddd MMM DD,YYYY");
    } else {
      return "";
    }
  }

  formattedTime(dateTime: string): string {
    if (dateTime) {
      return moment(dateTime).format("h:mm A");
    } else {
      return "";
    }
  }

  setTab(tab) {
    this.currentTab = tab; // Switch between 'manager' and 'staff'
  }

  closeModal() {
    this.$emit("close");
  }
}
